<template>
  <div class="popup-new" data-popup="popup-1" id="mypopup-classification">
    <div class="popup-inner">
      <a class="popup-close" data-toggle="modal" data-target="#mypopup-classification" href="#"><img src="../../assets/cross.png"></a>
      <div class="txt-box">
        <div class="img-txt">
          <img src="../../assets/Lowercase-Outline-white.png">
          <h2 class="white"><strong>Classes</strong> Outliers</h2>
          <div class="i-doc white float-left"><i class="fas fa-info-circle fa-lg" @click="openHelpTab"></i></div>
        </div>
      </div>
      <div class="table-holder">
        <table class="showHideMessage" v-if="showExplanation">
          <thead>
            <tr id="outliers-explanation">
              <td style="text-align: justify; width: 82%"><h3>Outliers are chapters that were misclassified during testing. We test the model by repeatedly building classification models using most of the chapters in the classes, and leaving out a few different chapters each time. Those chapters are then classified, and we see if the model classifies them correctly. If many such tests classify a chapter as the "wrong" class, it could mean that the chapter is simply different from the other chapters in its class.</h3></td>
              <td><button type="button" @click="hideExplanation()" class="button hoverable pull-right"><div class="anim"></div><img src="../../assets/ic_cancel_small.png"> Close</button></td>
            </tr>
          </thead>
        </table>
        <table class="fixed">
          <thead>
            <tr>
              <td>Error %</td>
              <!--<td>Actual</td>-->
              <td class="col">Name of Sample</td>
            </tr>
          </thead>
        </table>
        <div class="tabel-box">
          <table>
            <tbody>
            <tr v-for="error in errorObjects" :key="error.key" v-if="error.percentage >= 40">
              <td>{{error.percentage}}%</td>
              <!--<td>Not implemented</td>-->
              <td class="col">{{error.name}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import treeService from '../../texts/treeService'
import {summarizeKeys} from '../../texts'
import routeGlobals from '../../mixins/routeGlobals'

export default {
  name: 'outliersPopup',
  mixins: [routeGlobals],
  data () {
    return {
      errorObjects: [],
      showExplanation: false // removed in favor of the "i-doc" icon which links to the "new help"
    }
  },
  computed: {
    mapTextKeyToFractionOfErrors () {
      return this.$store.state.crossValidationResults.mapTextKeyToFractionOfErrors
    }
  },
  methods: {
    openHelpTab () { // directories defined in routeGlobals
      window.open(this.helpRootDir + this.helpPagesSubDir + 'outliers.htm')
    },
    updateErrorData () {
      const errorData = this.$store.state.crossValidationResults.mapTextKeyToFractionOfErrors
      if (!errorData) {
        return
      }
      const sortedKeys = treeService.treeSort(Object.keys(errorData))
      this.errorObjects = sortedKeys.map(key => ({
        key,
        name: summarizeKeys([key]),
        percentage: Math.round(errorData[key] * 100)
      }))
    },
    hideExplanation () {
      this.showExplanation = false
    }
  },
  watch: {
    mapTextKeyToFractionOfErrors: {
      immediate: true,
      handler: function () {
        this.updateErrorData()
      }
    }
  }
}
</script>
<style scoped>
  #mypopup-classification.popup-new .tabel-box{
    padding: 0;
  }
  #mypopup-classification.popup-new table{
    position: static;
    margin-bottom: 0;
  }
  .new-txt {
    width: 100%;
    padding: 0 20px 10px;
    overflow: hidden;
  }
  .new-txt h3{
    margin: 0;
  }
  .new-txt .button{
    width: 79px;
    min-width: 79px;
    height: 28px;
    color: #000;
    box-shadow: none;
    line-height: 28px;
    border-radius: 2px;
    margin: 0;
    background-color: #e0e0e0;
  }
  .new-txt .button img{
    display: inline-block;
    vertical-align: middle;
    margin: -1px 0 0 0;
  }
  .table-holder {
    display: flex;
    flex-direction: column;
    height: 88%;
  }
  .tabel-box {
    flex: 1;
    overflow-y: auto;
  }
  .txt-box {
    margin-bottom: 0;
  }
  .showHideMessage {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/experiment/outliersPopup.vue